import EonOneSettings from '@/components/eon-one/settings';

export default function EonOneSettingsScreen() {
  return <EonOneSettings />;
}
